import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/brandonwu/Documents/PTS/Gatsby/Instana-1-Day-Partner-Workshop/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    Lab 7 - Service Mapping <br />
  </span>;
;
export const _frontmatter = {};
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Lab Overview`}</h2>
    <p>{`Services are a part of application monitoring and provide a logical view of your system. Services are derived from infrastructure entities such as hosts, containers, and processes. In this lab you will learn to modify the ratings service of Robot Shop by changing its name from rs-ratings to rs-ratings-your last name. By the end of the lab, you should be able to find your service in your Application Perspective with its new name.`}</p>
    <h2>{`Step 1:`}</h2>
    <p>{`SSH into your host. `}</p>
    <pre><code parentName="pre" {...{}}>{`ssh ubuntu@<IP address>
`}</code></pre>
    <h2>{`Step 2:`}</h2>
    <p>{`Navigate to the robot-shop/ratings directory `}</p>
    <pre><code parentName="pre" {...{}}>{`cd /home/ubuntu/robot-shop/ratings 
`}</code></pre>
    <h2>{`Step 3:`}</h2>
    <p>{`Copy the file Docker file to Dockerfile.orig `}</p>
    <pre><code parentName="pre" {...{}}>{`sudo cp Dockerfile Dockerfile.orig 
`}</code></pre>
    <h2>{`Step 4:`}</h2>
    <p>{`Edit the file Dockerfile `}</p>
    <pre><code parentName="pre" {...{}}>{`sudo vi Dockerfile 
`}</code></pre>
    <p>{`And add the following line: `}</p>
    <pre><code parentName="pre" {...{}}>{`ENV INSTANA_SERVICE_NAME=rs-ratings-<your last name> 
`}</code></pre>
    <h2>{`Step 5:`}</h2>
    <p>{`Navigate back up to the robot-shop directory. `}</p>
    <pre><code parentName="pre" {...{}}>{`cd /home/ubuntu/robot-shop/ 
`}</code></pre>
    <h2>{`Step 6:`}</h2>
    <p>{`Execute: docker-compose build ratings `}</p>
    <pre><code parentName="pre" {...{}}>{`sudo docker-compose build ratings
`}</code></pre>
    <h2>{`Step 7:`}</h2>
    <p>{`Execute: docker-compose up -d ratings `}</p>
    <pre><code parentName="pre" {...{}}>{`sudo docker-compose up -d ratings 
`}</code></pre>
    <h2>{`Step 8:`}</h2>
    <p>{`In the UI, find your service in your Application Perspective and verify the new name. `}</p>
    <p>{`Click Application, then Services, and lastly verify the name. `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "87.15277777777777%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAABYlAAAWJQFJUiTwAAADGUlEQVQ4y3WUS28cRRSFGyT2SBEiAQRGUUAghPgX/CDASTYsohA7JuYhkZ/AnhUSyAtATBaBJBKaENlOBsfJ2GZ6evpVXY9bVfegujU2BikjXU1Vd/XXp8651cULK+/ET298HREQp0+PYl23EcCzi5cVYnTkI/nwnyqKs+exur6JHXuA0eF9jMZj/PDz7/j+l9/w4+gutn69g63RHWz9dBvf3R3ji8kEa9vbuFXOgcgw5OFOVXHuwnu88dU3PCDwk37G+2XJu7t7vP3HfX44fsCTx1OePDnkyd6Ux9MjvrVY8Ghe8f4wMCKzD4F9iCdVfPj+B/j25k2kHw0Wxnnw7ADu0QPQn/cQtIJxBIDhjAHIA86BjIGxFtY5dL3CoDVijCjOvPE2rmxsikF1p+C8h7cWuq5QzyqQI5D3WNQN1KDhQ5A1zhF8WhsC9lqHstcg51A8v/IuLm18KQo7ZTAYBwoRngETkqAI6wh12wsw+SRQ8iAfpGaDR6OdvKAoXn4TF9duCLBqByjjEEKA9wGdDgJMCsv5Am3byfUQIhyRjBP8YUM4ajVCAj732lu4dH1TgEo78SGy+A1LqTsYMTK0NiDyYIbME1TWRkZjI1pts4cJeHkJnDcKvbbyoHUenfYSUtpy0/VYNB2qupXtGuvkerr/uHWYd4PMi+KlFaxe+1yAg7ZQlsQXPqUwjZOSY+VpnhXm+dwE9IbASWFx7jwurmcPy7pH3Rs4yt70JiWax/8vCWcZyk5NmNYqe1iceR2fXNsQYNNraEsnC7UNAk+hnE5V6pkpv/gKPrp6/QTolttNpV0OKKWeUiYicGpxsSDmf2bs9x6VsgDHDPz4swysGpX7ML2dPHrdojMNjCX8XVZo2i6fWZ9DOz6/TzvCQuUuyAqXwFpZWB/l1ITURtRD2UYeKqtalIYoHxrxMQWTKimcdQYxhKXCq+vpIKOdTuHKGcJijljNMDRzaNLiYdspUZDgAvT/Akvt0Rl3DHwVq1fWgPkBqp1tLHZ30E0egf7ahZoegiLkVPRqEGjqR/K5N3NQXkDaOPl8/QM3FOHRAk6RRgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Lab 7",
        "title": "Lab 7",
        "src": "/Instana-1-Day-Partner-Workshop/static/0492eddf24aa919c6f7fc52437ecd0bc/3cbba/lab7.1.png",
        "srcSet": ["/Instana-1-Day-Partner-Workshop/static/0492eddf24aa919c6f7fc52437ecd0bc/7fc1e/lab7.1.png 288w", "/Instana-1-Day-Partner-Workshop/static/0492eddf24aa919c6f7fc52437ecd0bc/a5df1/lab7.1.png 576w", "/Instana-1-Day-Partner-Workshop/static/0492eddf24aa919c6f7fc52437ecd0bc/3cbba/lab7.1.png 1152w", "/Instana-1-Day-Partner-Workshop/static/0492eddf24aa919c6f7fc52437ecd0bc/0b124/lab7.1.png 1728w", "/Instana-1-Day-Partner-Workshop/static/0492eddf24aa919c6f7fc52437ecd0bc/91583/lab7.1.png 1886w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      